// Global
import React from 'react';

// Local
import { ComponentProps } from 'lib/component-props';
import { SkipNav, SkipNavVariant } from './SkipNav';

type SkipNavSitecoreProps = ComponentProps & {
  params: {
    FieldNames: SkipNavVariant;
  };
};

const PrimaryVariant: React.FC<SkipNavSitecoreProps> = (props) => {
  const variant = SkipNavVariant[props.params?.FieldNames] || SkipNavVariant.Primary;
  return <SkipNav variant={variant} />;
};

const SecondaryVariant: React.FC<SkipNavSitecoreProps> = (props) => {
  const variant = SkipNavVariant[props.params?.FieldNames] || SkipNavVariant.Secondary;
  return <SkipNav variant={variant} />;
};

export const Default = PrimaryVariant;
export const Primary = PrimaryVariant;
export const Secondary = SecondaryVariant;
export default PrimaryVariant;
